import React from 'react';
import clsx from 'clsx';

import Tabs from './Tabs';
import SearchForm from './SearchForm';

import styles from './SearchBar.module.scss';
import { useDeviceDetection } from '../utils/DeviceDetection';

export default function SearchBar({
	onSearchSubmit,
	collapsed,
	searchFor,
	dataSrc,
	onSearchForChange,
	page,
	onPageChange,
	rankedSearch,
	isMunicipality,
	onToggleFilters,
	onGeoLocationEnable,
	autocompleteResults,
	setAutocompleteResult,
	inputValue,
	setInputValue,
	openInfoWindow,
	searchParameters,
	showFiltersButton,
	setRankedSorting
}) {
	const isMobile = useDeviceDetection();

	const className = clsx(styles.root, collapsed && styles.collapsed);

	return (
		<div className={className}>
			{!isMobile ? (
				<Tabs
					searchFor={searchFor}
					onSearchForChange={onSearchForChange}
					rankedSearch={rankedSearch}
				/>
			) : null}

			<SearchForm
				page={page}
				onPageChange={onPageChange}
				rankedSearch={rankedSearch}
				isMunicipality={isMunicipality}
				onToggleFilters={onToggleFilters}
				onSearchSubmit={onSearchSubmit}
				onGeoLocationEnable={onGeoLocationEnable}
				autocompleteResults={autocompleteResults}
				setAutocompleteResult={setAutocompleteResult}
				inputValue={inputValue}
				setInputValue={setInputValue}
				openInfoWindow={openInfoWindow}
				dataSrc={dataSrc}
				searchParameters={searchParameters}
				showFiltersButton={showFiltersButton}
				setRankedSorting={setRankedSorting}
			/>
		</div>
	);
}
